<div class="row">
    <div class=" col-md-12 d-block pb-0 text-end ">
        <button class="button-cls" (click)="closeDialog()">
            <img src="assets/images/arrow_close.svg">
        </button>
    </div>
</div>
<div class="container p-0 mainnn">
    <div class="row m-0 d-flex justify-content-center bg-color position-relative     align-items-center">
        <div class="col-lg-12 position-relative">
            <h3 class="mt-0 mb-0  loginaccount">Log In to Your Account</h3>
        </div>
        <div class="col-lg-6 p-0  sideimg1">
            <div class="signupback">
                <img src="assets/images/login.jpg">
            </div>
        </div>
        <div class="col-lg-6 px-md-2 px-3 reset loginpagenew">
            
            <!-- login with phone -->
            <form *ngIf="mobilelogin" [formGroup]="loginForm" (submit)="onOtpSend(loginForm.value)">
                <div class="phonedetail d-grid ">
                    <div class="w-90 position-relative  mt-4">
                        <p class="position-absolute c_input border-end pe-2 me-2">+91 </p>
                        <!-- <p class="counternumber px-2 text-center"><span
                                *ngIf="loginForm.controls.phone_no.value.length<=9 && loginForm.controls.phone_no.value.length>0">0</span>{{loginForm.controls.phone_no.value.length}}/10
                        </p> -->
                        <input type="text" class="form-control countrycode" formControlName="phone_no" maxlength="10"
                            placeholder="Enter Mobile Number" appDigitOnly>
                        <!-- <small *ngIf="(submitted && loginForm.get('phone_no').invalid)">Phone Number is required
                        </small>  -->
                        <small *ngIf="phone_no?.errors?.pattern">
                            Enter a valid 10-digit phone number. Repeating digits like 1111111111 are not allowed.
                        </small>
                        <small *ngIf="submitted && loginForm.controls.phone_no.invalid" class="alert py-0 mb-0">
                            <small *ngIf="loginForm.controls['phone_no'].errors?.required">
                                Phone number is required.
                            </small>
                        </small>
                        <!-- <small *ngIf="phone_no?.errors?.pattern">Enter a valid 10-digit phone number.</small>
                        <small *ngIf="submitted && loginForm.controls.phone_no.invalid" class="alert py-0 mb-0">
                            <small *ngIf="loginForm.controls['phone_no'].errors.required">
                                Phone number is required.
                            </small>
                        </small> -->
                    </div>
                    <div class="w-90 position-relative  mt-4">
                       
                        <input type="text" class="form-control" formControlName="company_name"
                            placeholder="Enter Company Name">
                   
                        
                        <small *ngIf="submitted && loginForm.controls.company_name.invalid" class="alert py-0 mb-0">
                            <small *ngIf="loginForm.controls['company_name'].errors?.required">
                                Company Name is required.
                            </small>
                        </small>
                    </div>
                    <div class="w-90 position-relative  mt-4">
                       
                        <input type="text" class="form-control" formControlName="email" 
                            placeholder="Enter Company Email">
                   
                        
                        <small *ngIf="submitted && loginForm.controls.email.invalid" class="alert py-0 mb-0">
                            <small *ngIf="submitted && loginForm.controls['email']?.errors?.email">
                                Enter a valid email address.
                                </small>
                        </small>
                       
                    </div>
                </div>
                <div class="text-center mt-3" [title]="'Get OTP'">
                    <button type="submit" class="loginbtn" *ngIf="mobilelogin">Get OTP</button>
                </div>
                <div class="text-center mt-3">
                    <!-- <button type="button" title="login with gmail" class="align-middle
                     gmailloginbtn cursor-pointer"  (click)="guestLogin()">
                        Continue as Guest

                    </button> -->
                    <!-- <button type="button" class="loginbtn" (click)="guestLogin()">Continue as Guest</button> -->
                </div>

            </form>

            
            
        </div>
    </div>
</div>